import React, { useEffect, useState, Fragment } from 'react'
import ScriptLoader from './../../ScriptLoader'
import { GridItem } from './../../../Components/Page/StatsPageWrapper'
import { numberFormatterWithOptional2Dp } from './../../../Utils/Formatters'

/**
 */
const GLineChart = props => {
  // Setup a unique id we can use to render the Google stuff inside
  var [containerId] = useState('line-chart-' + new Date())

  useEffect(() => {
    google.charts.load('current', { 'packages': ['corechart'] })
    google.charts.setOnLoadCallback(function drawChart() {
      // Map our data to the Google data format
      var legend = props.axisKeys.map(
        key => props.data.legend.find(l => l.key == key).label,
      )
      var data = props.data.data.map(d => props.axisKeys.map(key => d[key]))
      var dataTableRawData = {
        cols: legend.map(label => ({ type: 'number', label })),
        rows: data.map(row => {
          return {
            c: row.map((v, i) => {
              return {
                v,
                f: `${numberFormatterWithOptional2Dp(v)} ${legend[i]}`,
              }
            }),
          }
        }),
      }

      // Create the data table
      var dataTable = new google.visualization.DataTable(dataTableRawData)

      var chart = new google.visualization.LineChart(
        document.getElementById(containerId),
      )

      var options = {
        height: 400,
        curveType: 'function',
        legend: { position: 'bottom' },
        hAxis: {
          title: props.data.legend.find(l => l.key == props.axisKeys[0]).label,
        },
        vAxis: {
          title: props.data.legend.find(l => l.key == props.axisKeys[1]).label,
        },
      }

      chart.draw(dataTable, options)
    })
  })
  return <div id={containerId} style={{ overflow: 'hidden' }} />
}

export default ({ title, ...otherProps }) => (
  <Fragment>
    <h1>{title}</h1>
    <GridItem>
      <ScriptLoader src="https://www.gstatic.com/charts/loader.js">
        <GLineChart {...otherProps} />
      </ScriptLoader>
    </GridItem>
  </Fragment>
)



// WEBPACK FOOTER //
// ./src/Components/Stats/GLineChart/index.js